module.exports = __webpack_public_path__ + "static/img/img_cabinet.0ba14c41.png";